import React, { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import styles from "styles/modules/notification.module.scss";
import ReactMarkdown from "react-markdown";

@withTranslation()
export default class HttpErrorNote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            details: false,
        };
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    open() {
        this.setState({ details: true });
    }

    close() {
        this.setState({ details: false });
    }

    render() {
        const { errorMessageText, errorMessage, t } = this.props;
        const { details } = this.state;
        const errorTitle = errorMessageText ? errorMessageText : t("notification.errorMessageTextEmpty");
        return (
            <div className={styles.httpErrorNote}>
                <i className="icon-error" />
                <div>
                    <ReactMarkdown source={errorTitle} />
                </div>
                {details && errorMessage && <div className="m-t-10">{<ReactMarkdown source={errorMessage} />}</div>}
                {details && errorMessage && (
                    <button onClick={this.close} type="button" className="error-toggle-button">
                        {t("notification.less")} <span className="top">&#8963;</span>
                    </button>
                )}

                {!details && errorMessage && (
                    <button onClick={this.open} type="button" className="error-toggle-button m-t-10">
                        {t("notification.more")} <span>&#8964;</span>
                    </button>
                )}
            </div>
        );
    }
}

HttpErrorNote.propTypes = {
    errorMessageText: PropTypes.string.isRequired,
};
